// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__-xcTM","box":"WorkspacesBox_box__141WL","node":"WorkspacesBox_node__6SBWO"};